import * as React from 'react';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = 16,
  className = '',
}) => {
  const id = React.useId();

  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id={`gradient-${id}`}>
          <stop offset='0%' stopColor='#f0f0f0' stopOpacity='1'>
            <animate
              attributeName='offset'
              values='-2; -2; 1'
              keyTimes='0; 0.25; 1'
              dur='1.5s'
              repeatCount='indefinite'
            />
          </stop>
          <stop offset='50%' stopColor='#e0e0e0' stopOpacity='1'>
            <animate
              attributeName='offset'
              values='-1; -1; 2'
              keyTimes='0; 0.25; 1'
              dur='1.5s'
              repeatCount='indefinite'
            />
          </stop>
          <stop offset='100%' stopColor='#f0f0f0' stopOpacity='1'>
            <animate
              attributeName='offset'
              values='0; 0; 3'
              keyTimes='0; 0.25; 1'
              dur='1.5s'
              repeatCount='indefinite'
            />
          </stop>
        </linearGradient>
      </defs>
      <rect
        x='0'
        y='0'
        width='100%'
        height='100%'
        fill={`url(#gradient-${id})`}
        rx='4'
      />
    </svg>
  );
};
